export const cstOrigins = [{
  number: 0,
  description: 'Nacional, exceto as indicadas nos códigos 3 a 5'
}, {
  number: 1,
  description: 'Estrangeira - Importação direta, exceto a indicada no código 6'
}, {
  number: 2,
  description: 'Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7'
}, {
  number: 3,
  description: 'Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%'
}, {
  number: 4,
  description: 'Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967 , e as Leis nºs 8 248/1991, 8.387/1991, 10.176/2001 e 11.484/2007'
}, {
  number: 5,
  description: 'Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%'
}, {
  number: 6,
  description: 'Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural'
}, {
  number: 7,
  description: 'Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural'
}];

export const cst = [{
  number: 0,
  description: 'Tributada integralmente'
}, {
  number: 10,
  description: 'Tributada e com cobrança do ICMS por substituição tributária'
}, {
  number: 20,
  description: 'Com redução de base de cálculo'
}, {
  number: 30,
  description: 'Isenta ou não tributada e com cobrança do ICMS por substituição tributária'
}, {
  number: 40,
  description: 'Isenta'
}, {
  number: 41,
  description: 'Não tributada'
}, {
  number: 50,
  description: 'Suspensão'
}, {
  number: 51,
  description: 'Diferimento'
}, {
  number: 60,
  description: 'ICMS cobrado anteriormente por substituição tributária'
}, {
  number: 70,
  description: 'Com redução de base de cálculo e cobrança do ICMS por substituição tributária'
}, {
  number: 90,
  description: 'Outras'
}];

export const cstIpi = [{
  number: 0,
  description: 'Entrada com Recuperação de Crédito'
}, {
  number: 1,
  description: 'Entrada Tributável com Alíquota Zero'
}, {
  number: 2,
  description: 'Entrada Isenta'
}, {
  number: 3,
  description: 'Entrada Não-Tributada'
}, {
  number: 4,
  description: 'Entrada Imune'
}, {
  number: 5,
  description: 'Entrada com Suspensão'
}, {
  number: 49,
  description: 'Outras Entradas'
}, {
  number: 50,
  description: 'Saída Tributada'
}, {
  number: 51,
  description: 'Saída Tributável com Alíquota Zero'
}, {
  number: 52,
  description: 'Saída Isenta'
}, {
  number: 53,
  description: 'Saída Não-Tributada'
}, {
  number: 54,
  description: 'Saída Imune'
}, {
  number: 55,
  description: 'Saída com Suspensão'
}, {
  number: 99,
  description: 'Outras Saídas'
}];

export const cstPisCofins = [{
  number: 1, 
  description: 'Operação Tributável com Alíquota Básica'
}, {
  number: 2, 
  description: 'Operação Tributável com Alíquota Diferenciada'
}, {
  number: 3, 
  description: 'Operação Tributável com Alíquota por Unidade de Medida de Produto'
}, {
  number: 4, 
  description: 'Operação Tributável Monofásica – Revenda a Alíquota Zero'
}, {
  number: 5, 
  description: 'Operação Tributável por Substituição Tributária'
}, {
  number: 6, 
  description: 'Operação Tributável a Alíquota Zero'
}, {
  number: 7, 
  description: 'Operação Isenta da Contribuição'
}, {
  number: 8, 
  description: 'Operação sem Incidência da Contribuição'
}, {
  number: 9, 
  description: 'Operação com Suspensão da Contribuição'
}, {
  number: 49, 
  description: 'Outras Operações de Saída'
}, {
  number: 50, 
  description: 'Operação com Direito a Crédito – Vinculada Exclusivamente a Receita Tributada no Mercado Interno'
}, {
  number: 51, 
  description: 'Operação com Direito a Crédito – Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'
}, {
  number: 52, 
  description: 'Operação com Direito a Crédito – Vinculada Exclusivamente a Receita de Exportação'
}, {
  number: 53, 
  description: 'Operação com Direito a Crédito – Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'
}, {
  number: 54, 
  description: 'Operação com Direito a Crédito – Vinculada a Receitas Tributadas no Mercado Interno e de Exportação'
}, {
  number: 55, 
  description: 'Operação com Direito a Crédito – Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação'
}, {
  number: 56, 
  description: 'Operação com Direito a Crédito – Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'
}, {
  number: 60, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno'
}, {
  number: 61, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'
}, {
  number: 62, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação'
}, {
  number: 63, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'
}, {
  number: 64, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação'
}, {
  number: 65, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação'
}, {
  number: 66, 
  description: 'Crédito Presumido – Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'
}, {
  number: 67, 
  description: 'Crédito Presumido – Outras Operações'
}, {
  number: 70, 
  description: 'Operação de Aquisição sem Direito a Crédito'
}, {
  number: 71, 
  description: 'Operação de Aquisição com Isenção'
}, {
  number: 72, 
  description: 'Operação de Aquisição com Suspensão'
}, {
  number: 73, 
  description: 'Operação de Aquisição a Alíquota Zero'
}, {
  number: 74, 
  description: 'Operação de Aquisição sem Incidência da Contribuição'
}, {
  number: 75, 
  description: 'Operação de Aquisição por Substituição Tributária'
}, {
  number: 98, 
  description: 'Outras Operações de Entrada'
}, {
  number: 99, 
  description: 'Outras Operações'
}];

export const csosn = [{
  number: 101,
  description: 'Tributada pelo Simples Nacional com permissão de crédito'
}, {
  number: 102,
  description: 'Tributada pelo Simples Nacional sem permissão de crédito'
}, {
  number: 103,
  description: 'Isenção do ICMS no Simples Nacional para faixa de receita bruta'
}, {
  number: 201,
  description: 'Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária'
}, {
  number: 202,
  description: 'Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária'
}, {
  number: 203,
  description: 'Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária'
}, {
  number: 300,
  description: 'Imune'
}, {
  number: 400,
  description: 'Não tributada pelo Simples Nacional'
}, {
  number: 500,
  description: 'ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação'
}, {
  number: 900,
  description: 'Outros'
}];